import { analyticsApiRef, ApiBlueprint, discoveryApiRef, fetchApiRef, identityApiRef } from "@backstage/frontend-plugin-api";
import { GainSightAnalytics } from "@backstage/plugin-analytics-module-gainsight";

export const analyticsApi = ApiBlueprint.make({
  name: 'gainsight-analytics',
  params: defineParams =>
    defineParams({
      api: analyticsApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ fetchApi, discoveryApi, identityApi }) => GainSightAnalytics.fromConfig(
        { fetchApi, discoveryApi, identityApi }
      ),
    }),
});